// Builds GET URLs for Lexiqamus / search_output_modified word searches opened in a new tab,
// mirroring the main search bar: preserve dictionary_collection_ids and explicit locale.

function appendDictionaryCollectionSearchParams(params) {
  const form = document.querySelector('form.search-bar-form');
  let appendedFromForm = false;

  if (form) {
    form.querySelectorAll('input[name="dictionary_collection_ids[]"]').forEach((input) => {
      if (input.type !== 'checkbox') return;
      if (input.checked && input.value !== '') {
        params.append('dictionary_collection_ids[]', input.value);
        appendedFromForm = true;
      }
    });
  }

  if (appendedFromForm) return;

  const current = new URLSearchParams(window.location.search);
  current.getAll('dictionary_collection_ids[]').forEach((id) => {
    if (id) params.append('dictionary_collection_ids[]', id);
  });
}

/**
 * @param {string} searchedText raw search string (not yet encoded)
 * @returns {string|null} full URL or null when not on Lexiqamus / search_output_modified
 */
export function wordSearchNewTabUrl(searchedText) {
  const path = window.location.pathname;
  const isLexiqamus = path.includes('/lexiqamus');
  const basePath = isLexiqamus ? '/lexiqamus' : '/search_output_modified';

  const params = new URLSearchParams();
  params.set('searched_text', searchedText);
  appendDictionaryCollectionSearchParams(params);

  try {
    const locale = new URLSearchParams(window.location.search).get('locale');
    if (locale && ['en', 'tu'].includes(locale)) {
      params.set('locale', locale);
    }
  } catch (_e) {
    // ignore
  }

  return `${basePath}?${params.toString()}`;
}
